import { ConvertUrlToFile } from '@/common/utils/ConvertUrlToFile';
import { fetchApi } from '@/config/axiosSetting';
import {
  PatchDamagedAdjusterAttachedImagesPropsType,
  PatchDamagedAdjusterAttachedImagesQueryParamsType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchDamagedAdjusterAttachedImages/patchDamagedAdjusterAttachedImagesQuery.type';
import { AdditionalApiUrlCreator } from '@/modules/adjusterReportModules/IncidentParticipants/utils/AdditionalApiUrlCreator';

export const patchDamagedAdjusterAttachedImagesFunction = ({
  damagedId,
  data,
  fileType,
  id,
  type,
}: PatchDamagedAdjusterAttachedImagesQueryParamsType &
  PatchDamagedAdjusterAttachedImagesPropsType): Promise<{}> => {
  const postData = new FormData();
  postData.append('image_id', data.image_id);
  const image = ConvertUrlToFile(data.image, 'image', 'image');
  postData.append('image', image);
  const url = AdditionalApiUrlCreator({
    id,
    TabType: type,
    userType: fileType,
  });

  return fetchApi({
    method: 'PATCH',
    url,
    data: postData,
    params: { damaged_id: damagedId },
  });
};
